// Foto em tela cheia com zoom: dois dedos para ampliar, toque duplo para aproximar ou voltar, arrastar quando ampliada.
import { useEffect, useRef } from 'react';
import { Animated, Image, Modal, PanResponder, Platform, Pressable, Text, View, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { t } from '../lib/i18n';

const dist = (ts: any[]) => Math.hypot(ts[0].pageX - ts[1].pageX, ts[0].pageY - ts[1].pageY);

export function VerFoto({ url, titulo, onClose }: { url: string | null; titulo?: string; onClose: () => void }) {
  const ins = useSafeAreaInsets();
  const { width, height } = useWindowDimensions();
  const escala = useRef(new Animated.Value(1)).current;
  const dx = useRef(new Animated.Value(0)).current;
  const dy = useRef(new Animated.Value(0)).current;
  const est = useRef({ s: 1, x: 0, y: 0, s0: 1, x0: 0, y0: 0, d0: 0, toque: 0 }).current;
  const aplicar = (s: number, x: number, y: number, animado = false) => {
    s = Math.max(1, Math.min(5, s));
    const mx = (width * (s - 1)) / 2, my = (height * (s - 1)) / 2;
    x = Math.max(-mx, Math.min(mx, x)); y = Math.max(-my, Math.min(my, y));
    est.s = s; est.x = x; est.y = y;
    if (animado) {
      Animated.parallel([Animated.spring(escala, { toValue: s, useNativeDriver: false }), Animated.spring(dx, { toValue: x, useNativeDriver: false }),
        Animated.spring(dy, { toValue: y, useNativeDriver: false })]).start();
    } else { escala.setValue(s); dx.setValue(x); dy.setValue(y); }
  };
  useEffect(() => { if (url) aplicar(1, 0, 0); }, [url]); // eslint-disable-line react-hooks/exhaustive-deps

  const pan = useRef(PanResponder.create({
    onStartShouldSetPanResponder: () => true,
    onMoveShouldSetPanResponder: () => true,
    onPanResponderGrant: (e) => {
      est.s0 = est.s; est.x0 = est.x; est.y0 = est.y; est.d0 = 0;
      const agora = Date.now();
      if (agora - est.toque < 280 && e.nativeEvent.touches.length <= 1) { aplicar(est.s > 1.2 ? 1 : 2.5, 0, 0, true); est.toque = 0; }
      else est.toque = agora;
    },
    onPanResponderMove: (e, g) => {
      const ts = e.nativeEvent.touches;
      if (ts.length >= 2) {
        const d = dist(ts);
        if (!est.d0) { est.d0 = d; est.s0 = est.s; return; }
        aplicar(est.s0 * (d / est.d0), est.x, est.y);
      } else if (est.s > 1) aplicar(est.s, est.x0 + g.dx, est.y0 + g.dy);
    },
    onPanResponderRelease: (_e, g) => {
      // foto sem zoom: puxar para baixo fecha
      if (est.s <= 1.05 && g.dy > 120) onClose();
      est.d0 = 0;
    },
  })).current;

  // navegador: a roda do mouse amplia
  const roda = Platform.OS === 'web' ? { onWheel: (e: any) => aplicar(est.s * (e.nativeEvent.deltaY < 0 ? 1.15 : 0.87), est.x, est.y) } : {};

  return (
    <Modal visible={!!url} transparent animationType="fade" onRequestClose={onClose}>
      <View style={{ flex: 1, backgroundColor: '#000' }}>
        <Animated.View {...pan.panHandlers} {...roda} style={{ flex: 1, transform: [{ translateX: dx }, { translateY: dy }, { scale: escala }] }}>
          {!!url && <Image source={{ uri: url }} style={{ width: '100%', height: '100%' }} resizeMode="contain" />}
        </Animated.View>
        <View pointerEvents="box-none" style={{ position: 'absolute', top: ins.top + 8, left: 12, right: 12, flexDirection: 'row', alignItems: 'center' }}>
          <Text style={{ color: '#fff', fontWeight: '700', fontSize: 16, flex: 1 }} numberOfLines={1}>{titulo ?? ''}</Text>
          <Pressable onPress={onClose} hitSlop={12} accessibilityLabel={t('Fechar')}
            style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: 'rgba(255,255,255,0.18)', alignItems: 'center', justifyContent: 'center' }}>
            <Text style={{ color: '#fff', fontSize: 20 }}>✕</Text></Pressable>
        </View>
        <Text pointerEvents="none" style={{ position: 'absolute', bottom: ins.bottom + 16, left: 0, right: 0, textAlign: 'center', color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>
          {t('Dois dedos ou toque duplo para ampliar')}</Text>
      </View>
    </Modal>
  );
}
